import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ChatWidgetState {
  showChatBox: boolean;
  isMinimized: boolean;
  sessionToReopen: any | null;
  lastOpenSession: any;
}

const initialState: ChatWidgetState = {
  showChatBox: false,
  isMinimized: false,
  sessionToReopen: null,
  lastOpenSession: null,
};

const chatWidgetSlice = createSlice({
  name: 'chatWidget',
  initialState,
  reducers: {
    openChatBox: (state) => {
      state.showChatBox = true;
      state.isMinimized = false;
    },
    closeChatBox: (state) => {
      state.showChatBox = false;
      state.isMinimized = false;
      state.sessionToReopen = null;
      state.lastOpenSession = null;
    },
    minimizeChatBox: (state) => {
      state.isMinimized = true;
    },
    maximizeChatBox: (state) => {
      state.isMinimized = false;
    },
    toggleMinimize: (state) => {
      state.isMinimized = !state.isMinimized;
    },
    reopenSession: (
      state,
      action: PayloadAction<{ sessionId: string; sessionData?: any }>
    ) => {
      state.showChatBox = true;
      state.isMinimized = false;
      // state.sessionToReopen = action.payload.sessionData || null;
      state.lastOpenSession = action.payload.sessionData || null;
    },
    setLastOpenSession: (state, action: PayloadAction<any>) => {
      state.lastOpenSession = action.payload;
    },
    clearSessionToReopen: (state) => {
      state.sessionToReopen = null;
    },
  },
});

export const {
  openChatBox,
  closeChatBox,
  minimizeChatBox,
  maximizeChatBox,
  toggleMinimize,
  reopenSession,
  setLastOpenSession,
  clearSessionToReopen,
} = chatWidgetSlice.actions;

export default chatWidgetSlice.reducer;
